// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"74":"e25b8687","1913":"40ec16c6"}[chunkId] || chunkId) + "." + {"74":"324c8ca733942ad0","1913":"7ea9287aa72fa62a","8021":"0ac5c058b81752ea"}[chunkId] + ".js";
};